define('presentation/signup/validators/signupSecurityValidator',[
        'common/promises/promiseFactory',
        'common/specifications/validPasswordSpecification',
        'presentation/common/validation/commonValidator',
        'presentation/common/validation/validationRule'
    ],
    function() {
        return function() {
            let self = this;

            let _facade = null;
            let _viewModel = null;
            let _commonValidator = null;

            const CommonValidatorConstructor = require('presentation/common/validation/commonValidator');
            const ValidationRulesConstructor = require('presentation/common/validation/validationRule');

            const ValidPasswordSpecificationConstructor = require('common/specifications/validPasswordSpecification');
            const _validPasswordSpecification = new ValidPasswordSpecificationConstructor();

            self.registerViewModel = (viewModel, facade) => {

                const validationRules = new ValidationRulesConstructor();
                validationRules.field("password")
                    .addValidationKeyUp(_validatePassword)
                    .addValidationI18n(_validateIsRequired, 'signupSecurity:passwordRequired')
                    .addValidationI18n(_validatePassword, 'signupSecurity:passwordInvalid');
                validationRules.field("confirmPassword")
                    .addValidationKeyUp(_validateConfirmPassword)
                    .addValidationI18n(_validateIsRequired, 'signupSecurity:confirmPasswordRequired')
                    .addValidationI18n(_validateConfirmPassword, 'signupSecurity:confirmPasswordInvalid');
                validationRules.field("verificationAnswer")
                    .addValidationKeyUp(_validateIsRequired)
                    .addValidationI18n(_validateIsRequired, 'signupSecurity:verificationAnswerRequired');

                validationRules.validationGroupKeyUp('isValid', ['password', 'verificationAnswer']);

                _viewModel = viewModel;
                _facade = facade;
                _commonValidator = new CommonValidatorConstructor(_viewModel, validationRules);
            };


            self.validate = () => {
                return _commonValidator.validate();
            };

            const _validatePassword = (userPassword) => {
                return _validPasswordSpecification.isSatisfiedBy(userPassword);
            };

            const _validateConfirmPassword = (confirmPassword) => {
                return _viewModel.password().trim() === confirmPassword.trim();
            };

            const _validateIsRequired = (field) => {
                return _commonValidator.isStringWithValue(field);
            };
        };
    });
